import { apiURL } from "../utils/Constants";

// Autenticazione admin: il token vive in un cookie httpOnly gestito dal server,
// quindi non è leggibile da JS. Tutte le chiamate usano credentials: "include"
// per inviare/ricevere il cookie.

export const login = async (username: string, password: string): Promise<{ status: boolean; message?: string }> => {
    const res: Response = await fetch(`${apiURL}user/login`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
    });
    try {
        return await res.json();
    } catch {
        return { status: res.ok };
    }
};

export const logout = async (): Promise<void> => {
    try {
        await fetch(`${apiURL}user/logout`, {
            method: "POST",
            credentials: "include",
        });
    } catch {
        // ignora: il logout lato client procede comunque
    }
};

export const checkAuth = async (): Promise<boolean> => {
    try {
        const res: Response = await fetch(`${apiURL}user/me`, {
            method: "GET",
            credentials: "include",
        });
        return res.ok;
    } catch {
        return false;
    }
};
